"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _clsx = _interopRequireDefault(require("clsx"));

var _propTypes = require("prop-types");

var _framerMotion = require("framer-motion");

var _Title = _interopRequireDefault(require("./Title"));

var _Description = _interopRequireDefault(require("./Description"));

var _Button = _interopRequireDefault(require("./Button"));

var _Instructions = _interopRequireDefault(require("./Instructions"));

var _elements = require("../../styles/elements");

var _AnimatedEllipsis = _interopRequireDefault(require("../AnimatedEllipsis/AnimatedEllipsis"));

var _AttachedContainer = _interopRequireDefault(require("./AttachedContainer"));

var _CopyField = _interopRequireDefault(require("./CopyField"));

var _Modal = require("./Modal.styles");

var _icons = require("../../assets/icons");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var animationPropsDefault = {
  initial: {
    opacity: 0,
    scale: 0.95
  },
  animate: {
    opacity: 1,
    scale: 1
  },
  exit: {
    opacity: 0
  },
  transition: {
    duration: 0.15
  }
};

var Modal = function Modal(_ref) {
  var portal = _ref.portal,
      children = _ref.children,
      onClose = _ref.onClose,
      open = _ref.open,
      dataTestId = _ref.dataTestId,
      className = _ref.className,
      isLoading = _ref.isLoading,
      shouldCloseOnClickBackdrop = _ref.shouldCloseOnClickBackdrop,
      backdropStyles = _ref.backdropStyles,
      panelCenter = _ref.panelCenter,
      animationProps = _ref.animationProps,
      backdropTransparency = _ref.backdropTransparency;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isLongLoading = _useState2[0],
      setIsLongLoading = _useState2[1];

  var loadingTimerRef = (0, _react.useRef)();
  var keydownRef = (0, _react.useRef)();
  var dialogRef = (0, _react.useRef)();
  var clearTimer = (0, _react.useCallback)(function () {
    clearTimeout(loadingTimerRef.current);
    loadingTimerRef.current = null;
    setIsLongLoading(false);
  }, []);
  var handleKeyDown = (0, _react.useCallback)(function (e) {
    if (e.key === 'Escape') {
      onClose();
    }
  }, [onClose]);
  (0, _react.useEffect)(function () {
    if (onClose && !keydownRef.current && open) {
      keydownRef.current = true;
      window.addEventListener('keydown', handleKeyDown);
    }

    return function () {
      if (onClose && keydownRef.current) {
        keydownRef.current = false;
        window.removeEventListener('keydown', handleKeyDown);
      }
    };
  }, [handleKeyDown, onClose, open]);
  (0, _react.useEffect)(function () {
    if (isLoading) {
      // After 0.75 seconds, show loading text too
      loadingTimerRef.current = setTimeout(function () {
        setIsLongLoading(true);
      }, 750);
    }

    return clearTimer;
  }, [clearTimer, isLoading]);
  (0, _react.useEffect)(function () {
    if (dialogRef.current && open) {
      dialogRef.current.focus();
    }
  }, [open]);
  var handleBackdropClick = (0, _react.useCallback)(function () {
    if (shouldCloseOnClickBackdrop && (0, _typeof2["default"])(onClose)) {
      onClose();
    }
  }, [shouldCloseOnClickBackdrop, onClose]);
  var handleClickContent = (0, _react.useCallback)(function (e) {
    e.stopPropagation();
  }, []);
  var loadingState = (0, _jsxRuntime.jsxs)("div", {
    className: "grui text-center",
    css: [_Modal.styles.loadingText, isLongLoading && _Modal.styles.showText, process.env.NODE_ENV === "production" ? "" : ";label:loadingState;"],
    children: [(0, _jsxRuntime.jsx)("p", {
      css: [_elements.paragraph.styles.preflight, _elements.text.styles.textNormal, _elements.text.styles.fontMedium, process.env.NODE_ENV === "production" ? "" : ";label:loadingState;"],
      className: "grui",
      children: "Just a moment"
    }), (0, _jsxRuntime.jsxs)("p", {
      css: [_elements.paragraph.styles.preflight, _elements.text.styles.textXs, process.env.NODE_ENV === "production" ? "" : ";label:loadingState;"],
      className: "grui",
      children: ["We are gathering your data", (0, _jsxRuntime.jsx)(_AnimatedEllipsis["default"], {})]
    })]
  });
  return (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/_reactDom["default"].createPortal((0, _jsxRuntime.jsx)(_framerMotion.AnimatePresence, {
      children: open && (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [(0, _jsxRuntime.jsx)("div", {
          css: [_Modal.styles.backdrop(backdropTransparency), backdropStyles, process.env.NODE_ENV === "production" ? "" : ";label:Modal;"],
          "aria-hidden": "true"
        }), (0, _jsxRuntime.jsx)("div", {
          role: "dialog",
          "aria-modal": "true",
          tabIndex: -1,
          css: [_elements.text.styles.textNormal, _Modal.styles.dialog, panelCenter && _Modal.styles.panelCenter, process.env.NODE_ENV === "production" ? "" : ";label:Modal;"],
          "data-test-id": dataTestId,
          onClick: handleBackdropClick,
          ref: dialogRef,
          children: (0, _jsxRuntime.jsxs)(_framerMotion.motion.div, _objectSpread(_objectSpread({
            css: [_Modal.styles.panel, isLoading && _Modal.styles.loadingPanel, process.env.NODE_ENV === "production" ? "" : ";label:Modal;"],
            className: (0, _clsx["default"])('grui mx-auto mb-15 flex flex-col items-center relative', className) // eslint-disable-next-line react/jsx-props-no-spreading

          }, animationProps), {}, {
            onClick: handleClickContent,
            children: [onClose && (0, _jsxRuntime.jsx)("button", {
              className: "grui drawer-close-btn",
              type: "button",
              css: [_elements.button.styles.preflight, _Modal.styles.closeBtn, process.env.NODE_ENV === "production" ? "" : ";label:Modal;"],
              onClick: onClose,
              children: (0, _jsxRuntime.jsx)(_icons.Close, {})
            }), isLoading ? loadingState : children]
          }), "panel")
        })]
      })
    }), document.querySelector(portal))
  });
};

Modal.Title = _Title["default"];
Modal.Description = _Description["default"];
Modal.CopyField = _CopyField["default"];
Modal.Button = _Button["default"];
Modal.Instructions = _Instructions["default"];
Modal.AttachedContainer = _AttachedContainer["default"];
Modal.propTypes = {
  portal: _propTypes.string.isRequired,
  children: _propTypes.node,
  onClose: _propTypes.func,
  open: _propTypes.bool,
  dataTestId: _propTypes.string,
  className: _propTypes.string,
  isLoading: _propTypes.bool,
  shouldCloseOnClickBackdrop: _propTypes.bool,
  backdropStyles: (0, _propTypes.oneOfType)([(0, _propTypes.shape)({
    styles: _propTypes.string
  }), _propTypes.func]),
  panelCenter: _propTypes.bool,
  animationProps: (0, _propTypes.shape)({}),
  backdropTransparency: (0, _propTypes.oneOf)(['light', 'normal'])
};
Modal.defaultProps = {
  children: undefined,
  onClose: undefined,
  open: false,
  dataTestId: undefined,
  className: undefined,
  isLoading: false,
  shouldCloseOnClickBackdrop: false,
  backdropStyles: undefined,
  panelCenter: false,
  animationProps: animationPropsDefault,
  backdropTransparency: 'normal'
};
var _default = Modal;
exports["default"] = _default;
//# sourceMappingURL=Modal.js.map